import { h } from "@stencil/core";

/**
 * Replaces the specified text snippets with a button and provides the option to add custom onClick functions
 * @param inputText
 * @param wordToReplace
 * @param buttonText
 * @param customFunction
 */
export const replacePlaceholderWithCustomFunctionButton = (inputText: string, wordToReplace: string, buttonText: string, customFunction?: (event: MouseEvent) => void) => {
	const regex: RegExp = new RegExp(`(${wordToReplace})`, "g");
	const textArray = inputText.split(regex);

	// Use a button instead of a link to prevent reloading of the page when switching to the edit view
	// ToDo: Reconsider using the FROK link with a future update to FROK 3 (with prevent default!?)
	return textArray.map(textPart => {
		if (regex.test(textPart)) {
			return (
				<button class="small-print-button" onClick={customFunction}>
					{buttonText}
				</button>
			);
		}

		return textPart;
	});
};
